import { Instance } from 'mobx-state-tree';
import { RouteTemplateConstraintCapacityDtoModelBase } from './RouteTemplateConstraintCapacityDtoModel.base';

/* The TypeScript type of an instance of RouteTemplateConstraintCapacityDtoModel */
export interface RouteTemplateConstraintCapacityDtoModelType extends Instance<typeof RouteTemplateConstraintCapacityDtoModel.Type> {}

/* A graphql query fragment builders for RouteTemplateConstraintCapacityDtoModel */
export {
  selectFromRouteTemplateConstraintCapacityDto,
  routeTemplateConstraintCapacityDtoModelPrimitives,
  RouteTemplateConstraintCapacityDtoModelSelector,
} from './RouteTemplateConstraintCapacityDtoModel.base';

/**
 * RouteTemplateConstraintCapacityDtoModel
 */
export const RouteTemplateConstraintCapacityDtoModel = RouteTemplateConstraintCapacityDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
